import * as React from "react";

function SvgIkonaObaSmery(props) {
  return (
    <svg
      data-name="Vrstva 1"
      viewBox="0 0 400 400"
      width="1em"
      height="1em"
      {...props}
    >
      <path d="M267.66 50h-31.78l69.46 67.48H57.44v22.09h247.92l-69.43 67.61h31.76l80.76-78.65L267.66 50zM132.34 192.82h31.78l-69.46 67.49h247.9v22.08H94.64L164.07 350h-31.76l-80.76-78.65 80.79-78.53z" />
    </svg>
  );
}

export default SvgIkonaObaSmery;

